import { createFileRoute } from '@tanstack/react-router';
import { SupplierInvoicesPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/supplier-invoices')({
  component: SupplierInvoicesRoute,
});

function SupplierInvoicesRoute() {
  const { orgId } = Route.useParams();
  return <SupplierInvoicesPage orgId={orgId} />;
}
